import PropTypes from 'prop-types';
import transformLayout from '@activebrands/core-web/libs/storyblok/utils/transform-layout';
import Text from 'components/content-components/Text';
import transformAnchorTag from '@activebrands/core-web/libs/storyblok/utils/transform-anchor-tag';
import transformPreviewEditable from '@activebrands/core-web/libs/storyblok/utils/transform-preview-editable';
import transformTextItems from '@activebrands/core-web/libs/storyblok/utils/transform-text-items';

const TextDataTransformerBlock = ({ content = {}, isTwoColumns = false, isThreeColumns = false }) => {
    const { _editable, anchorTag = [], items = [], textAlignment = 'left' } = content;

    return (
        <Text
            contentHorizontalAlignment={textAlignment}
            id={transformAnchorTag({ anchorTag })}
            items={transformTextItems({ items })}
            layout={transformLayout({ isTwoColumns, isThreeColumns })}
            sbEditable={transformPreviewEditable(_editable)}
        />
    );
};

TextDataTransformerBlock.propTypes = {
    content: PropTypes.object,
    isThreeColumns: PropTypes.bool,
    isTwoColumns: PropTypes.bool,
};

export default TextDataTransformerBlock;
